import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Button, Layout, Menu } from "antd";
import { useAuth } from 'react-oidc-context';

import 'react-sticky-header/styles.css';
import StickyHeader from 'react-sticky-header';

const Header = ({ location }) => {
    const auth = useAuth();
    const signOut = async () => {
        localStorage.removeItem('vertx_data');
        localStorage.removeItem('vertx_identity');
        await auth.signoutRedirect();
    };
    return (
    <StickyHeader
        header={

            <Layout.Header
                style={{
                    padding: "0 32px",
                    display: "flex",
                    alignItems: "center",
                    gap: 24
                }}
            >
                <div
                    style={{
                        flexShrink: 0
                    }}
                >
                    <h2
                        style={{
                            color: "#fff",
                            margin: 0,
                            marginRight: "1em",
                            display: "inline",
                            width: 100,
                            lineHeight: "54px"
                        }}
                    >
                        Vertx Portal
                    </h2>
                </div>
                <div
                    style={{
                        flex: 1,
                        minWidth: 0
                    }}
                >
                <Menu
                    theme="dark"
                    mode="horizontal"
                    selectedKeys={[location.pathname]}
                    style={{
                        lineHeight: "64px"
                    }}
                >
                    <Menu.Item key="/">
                        <Link to="/">Settings</Link>
                    </Menu.Item>
                    <Menu.Item key="/playground">
                        <Link to="/playground">Playground</Link>
                    </Menu.Item>
                    <Menu.Item key="/dashboard">
                        <Link to="/dashboard">Dashboard</Link>
                    </Menu.Item>
                    <Menu.Item key="/documentation">
                        <Link to="/documentation" target="_blank" rel="noopener noreferrer">Documentation</Link>
                    </Menu.Item>
                    <Menu.Item key="/api_reference">
                        <Link to="/api_reference" target="_blank" rel="noopener noreferrer">API reference</Link>
                    </Menu.Item>

                    {/*<Menu.Item key="/explore">*/}
                    {/*    <Link to="/explore">Explore</Link>*/}
                    {/*</Menu.Item>*/}

                    {/*<Menu.Item key="/swaggerui">*/}
                    {/*    <Link to="/swaggerui">SwaggerUI</Link>*/}
                    {/*</Menu.Item>*/}

                </Menu>
                </div>
                <div
                    style={{
                        flexShrink: 0,
                    }}
                >
                    <Button type="primary" onClick={signOut} >Sign out</Button>
                </div>
            </Layout.Header>
        }
        headerOnly={true}
        />
    );
};

export default withRouter(Header);
